import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IOcbLocalAgent } from '@app/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-local-agent-picker',
    templateUrl: './local-agent-picker.component.html',
    styleUrls: ['./local-agent-picker.component.scss'],
})
export class LocalAgentPickerComponent implements AfterViewInit {

    @Input()
    public localAgents: IOcbLocalAgent[];

    @Input()
    public isDisabled: boolean = false;

    @Input()
    public isRequired: boolean = false;

    @Input()
    public selectedItem: IOcbLocalAgent;

    @Output()
    public selectedItemChange = new EventEmitter<IOcbLocalAgent>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public ngAfterViewInit(): void {
        if (this.selectedItem) {
            this.selectBox.value = this.selectedItem.id;
        }
    }

    public onSelectedItemChange($event: IOcbLocalAgent): void {
        if ($event == null) {
            return;
        }
        this.selectedItemChange.emit($event);
    }
}
